import * as Preact from "preact"
import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import * as Objdict from "objdict"
import manifest from "@frog/source/manifest.js"

import "@frog/source/views/app/screens/CreditsScreen.view.less"

import Logo from "@frog/source/assets/images/skyline-tactics/logo.png"

export default class CreditsScreen {
    render() {
        // ..
    }
}
